export default {
  id: "thetradedesk",
  name: "The Trade Desk",
  color: "#2F5BEA",
  platformIds: ["thetradedesk", "ttd"],

  target: {
    supported: false,
    hint: "Coming soon",
    platformId: "thetradedesk",
    zipSuffix: "TheTradeDesk",
  },
};
